import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "#1F2830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M12 14c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4Zm7 7c-.9172-1.2676-2.0078-2.2736-3.2092-2.9601C14.5895 17.3534 13.3012 17 12 17c-1.3012 0-2.5895.3534-3.7908 1.0399C7.0078 18.7264 5.9172 19.7324 5 21"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1F2830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M12 23.75c6.2132 0 11.25-5.0368 11.25-11.25S18.2132 1.25 12 1.25.75 6.2868.75 12.5 5.7868 23.75 12 23.75Z"
})), 'SingleNeutralCircle');